import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import TreeView from 'devextreme-react/tree-view';
//import { navigation } from '../../app-navigation';
import {useNavigation} from '../../contexts/navigation';
import {useScreenSize} from '../../utils/media-query';
import './side-navigation-menu.scss';

import * as events from 'devextreme/events';
import {useAuth} from '../../contexts/auth';
import {PopupTitleWithIcon} from "../popup-title-with-icon/popup-title-with-icon";
import {faCircleInfo, faEnvelopeOpenText} from "@fortawesome/free-solid-svg-icons";
import ScrollView from "devextreme-react/scroll-view";
import Popup from "devextreme-react/popup";
import {Button} from "devextreme-react/button";
import {getPduAgreement, getPolicyCookies, getPolicyUrl} from "../../api/resource";
import ErrorPopup from "../error-popup/error-popup";
import { menuMatchesParameter } from '../../utils/admin.utils';

function menuItemVisible(item, selectedDog) {
    // «Управление доступом»: видимость только по parameter_menu из tc_resource;
    // роль 1 и НЭСК — на странице administration.js (как на Казани без parameter_menu в меню).
    return menuMatchesParameter(item.parameter_menu, selectedDog)
}
// import selectDogovor from "../select-dogovor/select-dogovor";
//import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
// import {getParamsFromResource} from "../../api/request";
// import notify from "devextreme/ui/notify";

function isAllUsersVisible(item) {
  return item?.all_users_visible === true || item?.all_users_visible === 'true'
}

function isConcludeContractItem(item) {
  if (!item) return false
  const path = item.path || ''
  if (path === '/add-dogovor' || path.startsWith('/add-dogovor/')) return true
  const text = String(item.text || '').toLowerCase()
  return text === 'заключить договор' || text === 'заключить договор/контракт'
}

function isVisibleWithoutContracts(item) {
  return isAllUsersVisible(item) || isConcludeContractItem(item)
}

const SideNavigationMenu = (props) => {
  const {
    children,
    selectedItemChanged,
    openMenu,
    compactMode,
    onMenuReady
  } = props;

  const { isLarge } = useScreenSize();
  const { dogovors, navigation, selectedDog} = useAuth()
  const [nav, setNav] = useState([])
  const [popupErrorVisible, setPopupErrorVisible] = useState(false)
  const [popupErrorText, setPopupErrorText] = useState('')
  const [popupIcon, setPopupIcon] = useState(null)
  const [popupTitle, setPopupTitle] = useState("Ошибка")
  const [popupWidth, setPopupWidth] = useState(500)
  const [popupClassNameColorIcon, setPopupClassNameColorIcon] = useState(null)
  const [policyUrl, setPolicyUrl] = useState(null)
  const [policyCookies, setPolicyCookies] = useState(null)

  useEffect(() => {
    (async function () {
      const res = await getPduAgreement()
      setPopupErrorText(res.result?.["0"].agreement_text)
      const resPolicy = await getPolicyUrl()
      setPolicyUrl(resPolicy?.result)
      const resCookies = await getPolicyCookies()
      setPolicyCookies(resCookies?.result)
    })()
  },[])

  const showNotify = async () =>{
    setPopupIcon(faEnvelopeOpenText)
    setPopupTitle('Согласие на обработку персональных данных')
    setPopupClassNameColorIcon('main-color-light')
    setPopupWidth(700)
    setPopupErrorVisible(true)
  }


 /* useEffect(()=> {
      (async function(){
        const icon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64L0 400c0 44.2 35.8 80 80 80l400 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 416c-8.8 0-16-7.2-16-16L64 64zm406.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L240 221.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l128-128z"/></svg>'
      let navString = ''
        navString = [{ text: "Заключить договор", path: "/add-dogovor", icon: icon, all_users_visible: true },
      { text: "Информация о договоре", icon: "product", path: "/dogovor", all_users_visible: false },
      { text: "Объекты и ТУ", icon: "mediumiconslayout", path: "/energoobjects", all_users_visible: false },
      { text: "Документы и оплаты", icon: "folder", all_users_visible: false, items:
      [ { text: "Задолженность", path: "/debt" },
      { text: "Финансовые документы", path: "/docs" },
      { text: "Оплаты", path: "/pays" },
      { text: "Лицевая карта", path: "/card" } ] },
      { text: "Показания", icon: "chart", all_users_visible: false, items: [ { text: "Подать показания", path: "/pokazania-new" },
      { text: "История показаний", path: "/pokazania-history" } ] },
      { text: "Цена на электроэнергию", path: "/price-energy", icon: "money" },
      { text: "Управление доступом", path: "/admin", icon: "preferences" },
      { text: "Планирование", icon: "event", path: "/planning", all_users_visible: false },
      { text: "Техническая поддержка", path: "/help", icon: "help" }];
        setNavigation(navString)
      //   navString = navString
      //   .replace(/\n/gs, '')
      //   .replace(/\r/gs, '')
      //   .replace(/ {2,}/gs, '')
      //   .replace(/\{ ?([^:]+):/gs, '{"$1":')
      //   .replace(/, ?([^:{]+):/gs, ',"$1":')
      //   navString = JSON.parse(navString)
      //   const res = await getParamsFromResource('MENU_NAVIGATION')
      // if (res.isOk) {
      //   navString = res.data?.paramValue;
      //   try {
      //     navString = JSON.parse(navString);
      //   } catch (e) {
      //     navString = navString
      //         .replace(/\n/gs, '')
      //         .replace(/\r/gs, '')
      //         .replace(/ {2,}/gs, '')
      //         .replace(/\{ ?([^:]+):/gs, '{"$1":')
      //         .replace(/, ?([^:{]+):/gs, ',"$1":')
      //     navString = JSON.parse(navString)
      //   }
      //   setNavigation(navString)
      // } else {
      //   notify(res.message,'error',5000)
      // }
    })()
  },[])*/

  const items = useMemo(
      normalizePath,
      [navigation, dogovors.length, isLarge, selectedDog]
  );

  function normalizePath () {
    // у рязани, в меню, отключаем агрегатор спроса
    // клонируем, чтобы не портить navigation в auth (иначе filter мутирует items навсегда)
    const source = process.env.REACT_APP_VISIBLE_AGREGATOR_SPROSA_IN_MENU === 'false'
      ? (navigation || []).filter(e => e.text !== 'Агрегатор спроса')
      : (navigation || [])
    let filterNavigation = source.map(item => item?.items
      ? { ...item, items: [...item.items] }
      : { ...item })
    setNav(filterNavigation)
    // без списка договоров в UI — только all_users_visible (countDogovors с логина может врать)
    // «Заключить договор» показываем и без флага (в т.ч. Рязань: all_users_visible false + parameter_menu 2,3)
    const noContracts = !dogovors?.length
    if (noContracts) {
      filterNavigation = filterNavigation.filter(isVisibleWithoutContracts)
      filterNavigation = filterNavigation
        .map(section => section.items
          ? { ...section, items: section.items.filter(isVisibleWithoutContracts) }
          : section)
        .filter(section => !section.items || section.items.length > 0)
    } else {
      //фильтруем parameter_menu (договор может иметь несколько ключей, напр. "2,4")
      filterNavigation = filterNavigation.filter(item => menuItemVisible(item, selectedDog))
      filterNavigation = filterNavigation.map(section => section.items
        ? { ...section, items: section.items.filter(item => menuItemVisible(item, selectedDog)) }
        : section)
    }

    return filterNavigation.map((item) => {
      const path = item.path && !(/^\//.test(item.path)) ? `/${item.path}` : item.path
      return {...item, path, expanded: isLarge};
    });
  }

  const { navigationData: { currentPath } } = useNavigation();

  const treeViewRef = useRef();
  const wrapperRef = useRef();
  const getWrapperRef = useCallback((element) => {
    const prevElement = wrapperRef.current;
    if (prevElement) {
      events.off(prevElement, 'dxclick');
    }

    wrapperRef.current = element;
    events.on(element, 'dxclick', e => {
      openMenu(e);
    });
  }, [openMenu]);

  useEffect(() => {
    const treeView = treeViewRef.current && treeViewRef.current.instance;
    if (!treeView) {
      return;
    }

    if (currentPath !== undefined) {
      treeView.selectItem(currentPath);
      treeView.expandItem(currentPath);
    }
    // если страница отсутствует в меню (app-navigation) переход из тулбара или прямая ссылка
    // очищаем селект в меню.
    //let nav = navigation.filter(e=> e.text !== 'Агрегатор спроса');
    //if (['/letters','/profile'].includes(currentPath)) treeView.unselectAll();
    let unselect = true;
    function unselectAll(items) {
      for (let subitems of items) {
        if (subitems.items) unselectAll(subitems.items) // рекурсивно вызывается для subitems
        if (subitems.path===currentPath) {unselect = false; return;}
      }
    }
    unselectAll(nav)
    unselect && treeView.unselectAll()

    if (compactMode) {
      treeView.collapseAll();
    }
  }, [currentPath, compactMode, nav]);

  const [visibleCookies, setVisibleCookies] = useState(false)

  //region agreement
  useEffect(()=> {
    (async function(){
      if (process.env.REACT_APP_NAME_ENV !== 'tatenergosbyt') {
        const agreement = getCookie('agreement')
        if (!agreement) {
          setVisibleCookies(true)
        }
      }
    })()
  },[])

  const popUpClose = () => {
    setCookie('agreement', '1', {'max-age': 60 * 60 * 24 * 365 * 10}); //10 лет
    setVisibleCookies(false)
  }

  // возвращает куки с указанным name,
  // или undefined, если ничего не найдено
  function getCookie(name) {
    let matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([.$?*|{}()[]\\\/+\^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
  }
  function setCookie(name, value, options = {}) {
    options = {
      path: '/',
      // при необходимости добавьте другие значения по умолчанию
      ...options
    };
    if (options.expires instanceof Date) {
      options.expires = options.expires.toUTCString();
    }
    let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);
    for (let optionKey in options) {
      updatedCookie += "; " + optionKey;
      let optionValue = options[optionKey];
      if (optionValue !== true) {
        updatedCookie += "=" + optionValue;
      }
    }
    //console.log(updatedCookie)
    document.cookie = updatedCookie;
  }
  //endregion

  return (
    <div
      className={'dx-swatch-additional side-navigation-menu'}
      ref={getWrapperRef}
    >
      {children}
      <div className={'menu-container'}>
        <TreeView
            className={compactMode ? 'compactModeTrue' : 'compactModeFalse'}
          ref={treeViewRef}
          items={items}
          keyExpr={'path'}
          selectionMode={'single'}
          focusStateEnabled={false}
          expandEvent={'click'}
          onItemClick={selectedItemChanged}
          onContentReady={onMenuReady}
          width={'100%'}
        />

        <ErrorPopup
            text={popupErrorText}
                    icon = {popupIcon}
                    width={popupWidth}
                    title ={popupTitle}
                    btnVisible={true}
                    visible={popupErrorVisible}
                    onOk={()=>{setPopupErrorVisible(false)}}
                    classNameColorIcon = {popupClassNameColorIcon}
        />
      </div>
      {visibleCookies &&
      <Popup
          showTitle={false}
          id="agreement-popup"
          className={'m-4'}
          title={'Соглашение'}
          showCloseButton={false}
          visible={visibleCookies}
          hideOnOutsideClick={false}
          onHiding={() => popUpClose()}
          animation={false}
          height='auto'
          maxHeight={'90%'}
          maxWidth="600px"
          position={{my: 'right bottom', at: 'right bottom', of: window, offset: "-25 -25"}}
          titleRender={()=>PopupTitleWithIcon(faCircleInfo, 'Соглашение',() => popUpClose(), false)}
      >
        <ScrollView className="big-input" width='100%' height='100%'>
          <p>Мы используем файлы cookie для корректной работы сайта, чтобы сделать его ещё удобнее.
            Продолжая пользоваться сайтом, Вы соглашаетесь с обработкой персональных данных.
            Ограничить использование cookie можно в настройках своего браузера.&nbsp;
            {policyCookies &&
                <><a href={policyCookies} target={'_blank'} rel={'noopener noreferrer'}>Пожалуйста, ознакомьтесь с политикой использования cookie</a>.&nbsp;</>
            }
            {policyUrl ?
            <>Подробнее об обработке персональных данных можно прочитать <a href={policyUrl} target={'_blank'} rel={'noopener noreferrer'}>здесь</a>.</>
                :
             <>Подробнее об обработке персональных данных можно прочитать <a className="dashed" id="link1" href='/' onClick={(e) => {showNotify(); e.preventDefault()}}>здесь</a>.</>
            }
          </p>
          <Button width={100} className={'float-right'} text='Ок' onClick={() => popUpClose()} />
        </ScrollView>
      </Popup>
      }
    </div>
  );
}

export default SideNavigationMenu
